import React from 'react'

const BannerLink: React.FC<{ href: string, img: string }> = ({ href, img }) => {

    return <a href={href} className='banner'>
        <img className='bannerImg' src={img}></img>
    </a>
}

export default BannerLink